import { getIdOrNull, requestWithPromise } from '..'
import { HttpMethods, makeQueryString } from '../apiHelper'
import apiClient from './apiClient'
import { ACCESS_KEY } from './internshipRequestPortal'

export const MUST_CONTAIN_AT_LEAST_ONE_SCHOOL_SECTION = 'api_school.public_create.must_contain_at_least_one_school_section'

export const createSchool = (user, school) => apiClient.post(user, 'api/schools', school)

export const getSchoolSpecialities = (user, school, parameters = { excludeRoot: true, contexts: [] }) =>
  apiClient.get(user, `api/schools/${getIdOrNull(school)}/school-specialities`, parameters)

export const getSchoolByUser = user => {
  return requestWithPromise(
    `/api/School/${user.school.id}`,
    HttpMethods.GET,
    null,
    user
  )
}

export const getMaccsLinkedInstitutions = (user, school) => apiClient.get(user, `api/schools/${getIdOrNull(school)}/institutions-maccs`)

export const oldUpdateSchool = (school, user) => {
  return requestWithPromise(
    `/api/School/${school.id}`,
    HttpMethods.PATCH,
    school,
    user
  )
}

export const editSchool = (school, user) => {
  return requestWithPromise(
    `/api/schools/${school.id}`,
    HttpMethods.PATCH,
    school,
    user
  )
}

export const fetchSchools = user => {
  return requestWithPromise(
    `/api/School/${user.school.id}`,
    HttpMethods.GET,
    null,
    user
  )
}

export const getSectionsWithContactPerson = (school, user) => {
  return requestWithPromise(
    `/api/schools/${school.id}/school-sections?withContactPerson=1`,
    HttpMethods.GET,
    null,
    user)
    .then(json => {
      if (json && json.data) {
        return json.data
      }
    })
}

export const fetchSchoolOptions = (user, school) => {
  return requestWithPromise(
    `/api/schools/${school.id}/school-options`,
    HttpMethods.GET,
    null,
    user
  )
}

export const getAllSchoolsPublic = () => apiClient.get(null, 'public/schools')

export const getAllSchools = (user, parameters = {}) => {
  return requestWithPromise(
    `/api/schools${makeQueryString(parameters)}`,
    HttpMethods.GET,
    null,
    user
  )
}

export const switchSchoolOption = (school, body, user) => {
  return requestWithPromise(
    `/api/schools/${school.id}/school-options`,
    HttpMethods.POST,
    body,
    user
  )
}

export const getSchoolStudents = (school, currentUser) => {
  return requestWithPromise(
    `/api/schools/${school.id}/students`,
    HttpMethods.GET,
    null,
    currentUser
  ).then(json => {
    return json?.data ?? {}
  })
}

export const getSchoolSchoolSections = (user, school, parameters = {}) => apiClient.get(user, `api/schools/${school.id}/school-sections`, parameters)

export const getAllData = (user, school) => {
  return requestWithPromise(
    `/api/schools/${school.id}/all`,
    HttpMethods.GET,
    null,
    user
  )
}

const SCHOOL_FORM = {
  [ACCESS_KEY]: '',
  institution: '',
  abbreviation: '',
  address: '',
  country: { id: null },
  email: '',
  managed: '',
  name: '',
  phone: '',
  premium: '',
  verified: '',
  sections: []
}
export const publicCreateSchoolFromPortal = (schoolForm = SCHOOL_FORM) => apiClient.post(null, 'public/schools', schoolForm)

export const createSchoolSection = (user, school, section) => {
  return apiClient.post(user, `api/schools/${getIdOrNull(school)}/sections/${getIdOrNull(section)}`, {})
}
